import React, { useState } from 'react';
import BusinessUserDetail from './BusinessUserDetail';
import { BusinessUser } from '../../CRUD/CampSites/types';

interface BusinessUserListProps {
  businessUsers: BusinessUser[];
  onEdit: (businessUser: BusinessUser) => void;
  onDelete: (id: number) => void;
  onView: (businessUser: BusinessUser) => void;
}

const BusinessUserList: React.FC<BusinessUserListProps> = ({ businessUsers, onEdit, onDelete, onView }) => {
  const [selectedBusinessUser, setSelectedBusinessUser] = useState<BusinessUser | null>(null);

  return (
    <>
      <div className='business-user-list'>
        {selectedBusinessUser ? (
          <BusinessUserDetail
            businessUser={selectedBusinessUser}
            onClose={() => setSelectedBusinessUser(null)}
            onEdit={onEdit}
          />
        ) : (
          <section className='business-user-list-section'>
            <div className='business-user-list'>
              <div className="list-header">
              <span>Company Name</span>
                <span>Name</span>
                <span>Email</span>
                <span>Business Code</span>
                <span>Actions</span>
              </div>
              <ul className="list-group">
                {businessUsers.map(user => (
                  <li key={user.id} className="list-group-item">
                    <span className="business-user-field">{user.companyName}</span>
                    <span className="business-user-field">{user.name}</span>
                    <span className="business-user-field">{user.email}</span>
                    <span className="business-user-field">{user.businessCode}</span>
                    <div className="business-user-actions">
                     
                  
                      <div className="action-button">
                        <button className="btn btn-sm btn-outline-info me-2" onClick={() => onView(user)}>
                          <i className="fas fa-eye"></i> View
                        </button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default BusinessUserList;